import React from "react";
import { Box, Typography, IconButton, Paper } from "@mui/material";
import { ChevronLeft, ChevronRight } from "@mui/icons-material";
import CalendarGrid from "./CalendarGrid";

const Calendar = ({
  date,
  onNavigateMonth,
  onAddDate,
  regularizations,
  statuses,
}) => {
  const monthNames = [
    "JANUARY",
    "FEBRUARY",
    "MARCH",
    "APRIL",
    "MAY",
    "JUNE",
    "JULY",
    "AUGUST",
    "SEPTEMBER",
    "OCTOBER",
    "NOVEMBER",
    "DECEMBER",
  ];

  return (
    <Paper sx={{ flex: 1, p: 3 }}>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          mb: 2,
        }}
      >
        <button onClick={() => onNavigateMonth(-1)}>
          <IconButton size="small">
            <ChevronLeft />
          </IconButton>
          <span className="text-xs">Prev</span>
        </button>

        <Typography variant="h6" sx={{ fontWeight: "bold", color: "#333" }}>
          {monthNames[date.getMonth()]} {date.getFullYear()}
        </Typography>

        <button onClick={() => onNavigateMonth(1)}>
          <span className="text-xs mb-2">Next</span>
          <IconButton size="small">
            <ChevronRight />
          </IconButton>
        </button>
      </Box>

      <CalendarGrid
        date={date}
        onAddDate={onAddDate}
        regularizations={regularizations}
        statuses={statuses}
      />
    </Paper>
  );
};

export default Calendar;
